import {Component, OnInit, Output, EventEmitter, Input, ViewChild} from '@angular/core';
import {timer} from 'rxjs';
import {TrelloCheckItem} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import {InputNumber} from 'primeng/inputnumber';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-task-checkitem-tags',
  templateUrl: './task-checkitem-tags.component.html',
  styleUrls: ['./task-checkitem-tags.component.scss']
})
export class TaskCheckitemTagsComponent implements OnInit {
  selectedTags: any[] = [];

  @Output()
  tagChangedEmitter = new EventEmitter<SelectItem[]>();

  @Input()
  tags = [];

  @Input()
  checkItem: TrelloCheckItem;

  showInput: boolean;

  inputAmount = 0;

  @ViewChild('tagAmount', {static: false})
  tagAmount: InputNumber;

  lastClicked: any;

  constructor() {
  }

  ngOnInit() {
    if (this.checkItem && this.checkItem.tags) {
      this.checkItem.tags.forEach(tag => {
        this.tags.forEach(tag2 => {
          if (tag2.value.name === tag.type.name) {
            if (tag.type.name === 'Amount') {
              this.showInput = true;
              this.checkItem.changeOrderAmount = tag.amount
            }

            this.selectedTags.push(tag2)
            return;
          }
        })
      });

      this.checkItem.tagTypes = this.selectedTags.map(tagg => tagg.value.name);
    }
  }

  tagChanged(event) {
    this.tagChangedEmitter.emit(this.selectedTags);

    if (this.lastClicked?.value?.name === 'Amount') {
      this.showInput = !this.showInput;

      if (this.showInput) {
        timer(1).subscribe(emit => {
          const tempInput = this.tagAmount.input.nativeElement as HTMLInputElement;
          if (tempInput) {
            tempInput.focus()
            tempInput.setSelectionRange(0, this.checkItem.changeOrderAmount);
          }
        })
      }
    }


  }

  optionClicked(event) {
    this.lastClicked = event.option
  }

  onInputClick(event) {
    event.stopPropagation()
  }

}
